import AccountsCont from '../../components/People/Accounts/AccountsCont'
import EmployeeLoanCont from '../../components/People/EmployeeLoan/EmployeeLoanCont'
import PerformanceCont from '../../components/People/Performance/PerformanceCont'
import TimesheetCont from '../../components/People/Timesheet/TimesheetCont'
import React, { lazy, Suspense } from 'react'

import NoMatchComponent from '../../components/NoMatch.jsx'
import { Route, Switch } from 'react-router-dom'
import AddPayQuery from '../../components/People/Member/PayQuery/AddPayQuery/AddPayQuery'
import ViewPayQuery from '../../components/People/Member/PayQuery/ViewPayQuery/ViewPayQuery'
import Dropdowns from '../../modules/Dropdowns'
import AddContractCont from '../../components/People/Member/Contract/AddContract/AddContractCont'
import ViewContractCont from '../../components/People/Member/Contract/ViewContract/ViewContractCont'
import GroupsCont from '../../components/Main/Group/GroupsCont'
import ViewWorkOrdersCont from '../../components/People/Member/Contract/ViewContract/WorkOrders/ViewWorkOrders/ViewWorkOrdersCont'
import AddWorkOrdersCont from '../../components/People/Member/Contract/ViewContract/WorkOrders/AddWorkOrders/AddWorkOrdersCont'
import CenterSpin from '../../elements/CenterSpin'
import Devices from '../../components/People/Devices/Devices'
import PayrollCont from '../../components/People/Payroll/PayrollCont'
import AddPayrollCont from '../../components/People/Payroll/AddPayroll/AddPayrollCont'
import SalariesCont from '../../components/People/Salaries/SalariesCont'
import AddSalaryCont from '../../components/People/Salaries/AddSalary/AddSalaryCont'
import AddPayrollClaimCont from '../../components/People/PayrollClaim/AddPayrollClaim/AddPayrollClaimCont'
import PayrollClaimCont from '../../components/People/PayrollClaim/PayrollClaimCont'

const AsyncDashboard = lazy(() => import('../../components/People/Dashboard'))
const AsyncMember = lazy(() => import('../../components/People/Member/MemberContainer'))
const AsyncNewEmployee = lazy(() =>
  import('../../components/People/TeamList/NewEmployee/NewEmployee')
)

export default function PeopleRouter(props) {
  const url = props.match.url

  React.useLayoutEffect(() => {
    // cache dropdowns
    new Dropdowns({ dropdown: 'general', name: 'currency' }).set()
    new Dropdowns({ dropdown: 'employee', name: 'uom' }).set()
    new Dropdowns({ dropdown: 'employee', name: 'valueType' }).set()
    new Dropdowns({ dropdown: 'employee', name: 'contract' }).set()
    new Dropdowns({ dropdown: 'employee', name: 'statutory' }).set()
    new Dropdowns({ dropdown: 'employee', name: 'leaves' }).set()
  }, [])

  return (
    <Suspense fallback={<CenterSpin fontSize={50} />}>
      <Switch>
        <Route path={`${url}/dashboard/new`} component={AsyncNewEmployee} />
        <Route path={`${url}/dashboard`} component={AsyncDashboard} />
        <Route
          path={`${url}/member/:key/contracts/:contractKey/workOrders/new`}
          component={AddWorkOrdersCont}
        />

        <Route
          path={`${url}/member/:key/contracts/:contractKey/workOrders/:workOrderKey/update`}
          component={AddWorkOrdersCont}
        />
        <Route
          path={`${url}/member/:key/contracts/:contractKey/workOrders/:workOrderKey`}
          component={ViewWorkOrdersCont}
        />
        <Route path={`${url}/member/:key/contracts/new`} component={AddContractCont} />
        <Route
          path={`${url}/member/:key/contracts/:contractKey/update`}
          component={AddContractCont}
        />
        <Route path={`${url}/member/:key/payQuery/new`} component={AddPayQuery} />
        <Route path={`${url}/member/:key/payQuery/:payQueryKey/update`} component={AddPayQuery} />
        <Route
          path={`${url}/member/:key/contracts/:contractKey/view`}
          component={ViewContractCont}
        />
        <Route path={`${url}/member/:key/payQuery/:payQueryKey/view`} component={ViewPayQuery} />
        <Route path={`${url}/member/:key`} component={AsyncMember} />
        <Route path={`${url}/groups`} component={GroupsCont} />
        <Route path={`${url}/payrolls/:key/update`} component={AddPayrollCont} />
        <Route path={`${url}/payrolls/new`} component={AddPayrollCont} />
        <Route path={`${url}/payrolls`} component={PayrollCont} />
        <Route path={`${url}/payrollClaims/:key/update`} component={AddPayrollClaimCont} />
        <Route path={`${url}/payrollClaims/new`} component={AddPayrollClaimCont} />
        <Route path={`${url}/payrollClaims`} component={PayrollClaimCont} />
        <Route path={`${url}/salaries/:key/update`} component={AddSalaryCont} />
        <Route path={`${url}/salaries/new`} component={AddSalaryCont} />
        <Route path={`${url}/salaries`} component={SalariesCont} />
        <Route path={`${url}/devices`} component={Devices} />
        <Route path={`${url}/access`} component={AccountsCont} />
        <Route path={`${url}/timesheets`} component={TimesheetCont} />
        <Route path={`${url}/employeeLoan`} component={EmployeeLoanCont} />
        <Route path={`${url}/performance`} component={PerformanceCont} />

        <Route component={NoMatchComponent} />
      </Switch>
    </Suspense>
  )
}
